import { Saga } from './workers';

export default Saga;



// WEBPACK FOOTER //
// ./src/redux/questions/category-options/sagas.js